import ErrorPage from 'next/error';
import propTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getMenus} from '../actions/menus';
import {getId as getProject} from '../actions/projects';
import getArray from '../utils/misc';
import {Container, Layout} from '../components';
import * as theme from '../constants/theme';

const {GUTTER} = theme;

const Project = ({mainMenu, notFound, project}) => notFound ? <ErrorPage statusCode={404}/> : (
	<Layout mainMenu={mainMenu}>
		<Container>
			{project && (
				<div className='Project'>

					<div className='ProjectInfo'>
						<div className='ProjectInfo-box'>
							<div className='ProjectInfo-client'>
								<span className='client'>Klient: </span>
								<strong className='name' dangerouslySetInnerHTML={{__html: project.acf.client}}/>
							</div>
							<h2 className='title' dangerouslySetInnerHTML={{__html: project.acf.title}}/>
							<p className='description' dangerouslySetInnerHTML={{__html: project.acf.description}}/>
							<p className='description' dangerouslySetInnerHTML={{__html: project.acf.long_description}}/>
						</div>
						<div className='ProjectInfo-image'>
							{project.acf.image.url && <img src={project.acf.image.url}/>}
						</div>
					</div>
					<div className='ProjectInfo ProjectInfo--right'>
						{project.acf.image3.url &&
							<div className='ProjectInfo-image'>
								<img src={project.acf.image3.url}/>
							</div>
						}

						{project.acf.image2 &&
							<div className='ProjectInfo-image'>
								<img src={project.acf.image2 && project.acf.image2.url}/>
							</div>
						}

					</div>
				</div>
			)}
		</Container>
		<style jsx>
			{`
				.Project {
					padding: ${GUTTER};
				}

				.ProjectInfo {
					display: flex;
					width: 100%;
					flex-flow: column;
				}

				.ProjectInfo-box {
					width: 100%;
					order: 1;
					padding: calc(${GUTTER} / 2) 0;
				}

				.ProjectInfo-client {
					display: flex;
				}

				.ProjectInfo-client .client {
					margin-right: .2em;
				}

				.description {
					padding: calc(${GUTTER} / 2) 0;
				}

				.ProjectInfo-image {
					width: 100%;
					order: 2;
				}

				.ProjectInfo-image > img {
					margin: 0 auto;
					display: block;
				}

				@media (min-width: 48em) {
					.ProjectInfo {
						flex-flow: row nowrap;
						padding: ${GUTTER} 0;
					}

					.ProjectInfo-box {
						width: 60%;
						padding: calc(${GUTTER} / 2);
					}

					.ProjectInfo-client {
						padding-bottom: calc(${GUTTER} / 4);
					}

					.ProjectInfo-box .title {
						font-size: 2.5em;
						padding-bottom: calc(${GUTTER} / 2);
					}

					.ProjectInfo-image {
						width: 60%;
					}

					.ProjectInfo--left .ProjectInfo-box {
						order: 1;
						padding: 0 calc(${GUTTER} / 2) 0 0;
					}

					.ProjectInfo--left .ProjectInfo-image {
						order: 2;
					}

					.ProjectInfo--right > .ProjectInfo-box {
						order: 2;
						padding: 0 0 0 calc(${GUTTER} / 2);
					}

					.ProjectInfo--right > .ProjectInfo-image {
						order: 1;
					}
				}
			`}
		</style>
	</Layout>
);

Project.propTypes = {
	mainMenu: propTypes.array,
	notFound: propTypes.bool,
	project: propTypes.object
};

Project.getInitialProps = async ({isServer, query, res, store}) => {
	const slug = query.slug.replace(/^\/|\/$/g, '');
	const fns = [store.dispatch(getProject(slug))];

	if (isServer) {
		fns.push(
			store.dispatch(getMenus())
		);
	}

	const [post] = await Promise.all(fns);
	const notFound = !post.value;

	if (notFound && res) {
		res.statusCode = 404;
	}

	return {notFound, slug};
};

export default connect((state, props) => ({
	mainMenu: getArray(Object.values(state.menus.data).find(x => x.slug === 'main'), 'items'),
	project: Object.values(state.projects.data).find(x => x.title === props.title)
}))(Project);



// WEBPACK FOOTER //
// pages/project.js